import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SessionThunksI } from './types';

interface PropsI {
  sessionThunks: SessionThunksI;
}

const useCheckSession = (sessionThunks: SessionThunksI): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(sessionThunks.check());
  });
};

const InitSession: React.FC<PropsI> = ({ sessionThunks }) => {
  useCheckSession(sessionThunks);

  return null;
};

export default InitSession;
